const MyCialAdminDomains = {
  development: 'http://localhost:4001',
  staging: 'http://staging.admin.cialdnb.com',
  sandbox: 'http://sandbox.admin.cialdnb.com',
  production: 'https://admin.cialdnb.com'
};

export default MyCialAdminDomains;
